export const daysoftheweek = [
    {
        id : 'Sunday', 
        value: 'Sunday',
        price: 0
    },
    {
        id : 'Monday', 
        value: 'Monday',
        price: 0
    },
]